//Getting Usercentrics consent array from the consent object
import afUsercentricsConsentArray from "../../../Assets/afUsercentric";

(function() {
    //Array that has infos about the consent regarding services
    let checkArray = [];
    let checkArrayLength = 0;

    //Page should reload in case the consent for some service(s) has changed
    window.addEventListener('load', function (event) {
        let thirdPartyServicesGlobal;
        if(localStorage.getItem("ucData")) {
            thirdPartyServicesGlobal = afUsercentricsConsentArray();
        }
        else {
            thirdPartyServicesGlobal = [{name: "Google Maps", consent:{status:false}}];
        }
        const thirdPartyServicesLength = thirdPartyServicesGlobal.length;
        for (let i = 0; i < thirdPartyServicesLength; i++) {
            checkArray.push(thirdPartyServicesGlobal[i].consent.status);
        }
        checkArrayLength = checkArray.length;

        //Google Maps check
        const placeholder = document.querySelectorAll('.google-map-placeholder')[0];
        if(thirdPartyServicesGlobal.filter(i => (i.name === "Google Maps" && i.consent.status === true)).length > 0) {
            placeholder.parentElement.removeChild(placeholder);
            document.getElementById("af-google-maps-api-script").src ="https://maps.googleapis.com/maps/api/js?key=AIzaSyCwYJIENwVRKHbGl_ak3xyNFCfCxDqHAHc&loading=async";
        }
        else {
            placeholder.addEventListener('click',function(){UC_UI.showFirstLayer();});
            const map = document.querySelectorAll(".acf-map")[0];
            map.parentElement.removeChild(map);
        }
    });
})();
